module.exports = __webpack_public_path__ + "images/emoji/on.2fdc2c4a898ef4ec4c27.png";